import React, { Component } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

import Slider5 from "./../../images/main-slider/slide11.jpg";
import Slider6 from "./../../images/main-slider/slide12.jpg";
import Slideriv from "./../../images/main-slider/slide5.jpg";
import Sliderv from "./../../images/main-slider/slide10.jpg";

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div className="owl-nav">
      <div className="owl-next flaticon-right-arrow" onClick={onClick} />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div className="owl-nav">
      <div
        className=" owl-prev flaticon-left-arrow"
        onClick={onClick}
        style={{ zIndex: 1 }}
      />
    </div>
  );
}

class Index7Slider extends Component {
  render() {
    var settings = {
      arrows: true,
      dots: false,
      slidesToShow: 1,
      infinite: true,
      autoplay: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };
    return (
      <Slider className="owl-slider owl-carousel owl-theme" {...settings}>
        <div className="item slide-item">
          <div className="slide-item-img">
            <img src={Slider5} className="w-100" alt="" />
          </div>
          <div className="slide-content overlay-black-middle">
            <div className="slide-content-box container">
              <div className="max-w600 text-white ">
                <h6 className="dz-title">
                  Welcome to Juba Proper International College <br />
                </h6>
                <p>
                  Giving your child a great start in life. Every child deserves
                  a quality and a well rouded-education in their informative
                  year
                </p>
               
              </div>
            </div>
          </div>
        </div>
        <div className="item slide-item">
          <div className="slide-item-img">
            <img src={Slideriv} className="w-100" alt="" />
          </div>
          <div className="slide-content overlay-black-middle">
            <div className="slide-content-box container">
              <div className="max-w600 text-white justify-content-center">
                <h2 className="dz-title">
                  Keep Learning
                  <br />
                </h2>
                <p>
                  Education is the passport to the future, for tomorrow belongs
                  to those who prepare for it today.
                </p>
                <div className="slide-btns">
                  <Link
                    to={"/about-2"}
                    className="site-button  m-r10 radius-xl primary button-lg"
                  >
                    About Us
                  </Link>
                  <Link
                    to={"/service"}
                    className="site-button  radius-xl white  button-lg"
                  >
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="item slide-item">
          <div className="slide-item-img">
            <img src={Slider6} className="w-100" alt="" />
          </div>
          <div className="slide-content overlay-black-middle">
            <div className="slide-content-box container">
              <div className="max-w600 text-white justify-content-center">
                <h2 className="dz-title">
                  Start Now
                  <br />
                </h2>
                <p>
                  The beautiful thing about learning is that nobody can take it
                  away from you.
                </p>
                <div className="slide-btns">
                  <Link
                    to={"/about-2"}
                    className="site-button  m-r10 radius-xl primary button-lg"
                  >
                    About Us
                  </Link>
                  <Link
                    to={"/service"}
                    className="site-button  radius-xl white  button-lg"
                  >
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="item slide-item">
          <div className="slide-item-img">
            <img src={Sliderv} className="w-100" alt="slide-4" />
          </div>
          <div className="slide-content overlay-black-middle">
            <div className="slide-content-box container">
              <div className="max-w600 text-white justify-content-center">
                <h2 className="dz-title">
                  George Washington Carver
                  <br />
                </h2>
                <p>
                  “Ninety-nine percent of the failures come from people who have
                  the habit of making excuses.”
                </p>
                <div className="slide-btns">
                  <Link
                    to={"/about-1"}
                    className="site-button  m-r10 radius-xl primary button-lg"
                  >
                    About Us
                  </Link>
                  <Link
                    to={"/service"}
                    className="site-button  radius-xl white  button-lg"
                  >
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Slider>
    );
  }
}

export default Index7Slider;
